import React from "react";
import T from "prop-types";
import { NoteTooltip } from "MODULES/shared/components";

export default function LineItemQtyCell({
  lineItem,
  hideTooltip,
  type = "PO"
}) {
  return (
    <span>
      {lineItem.purchase_status === "full" && (
        <NoteTooltip
          icon="fa-check-square"
          placement="top"
          note={type === "PO" ? "Full Purchase" : "Full Qty Purchase"}
          color="#4CAF50"
          hideTooltip={hideTooltip}
        />
      )}
      {lineItem.purchase_status === "partial" && (
        <NoteTooltip
          icon="fa-star-half-o"
          placement="top"
          note={
            type === "PO"
              ? "Entire quantity not purchased from this vendor"
              : "Partial Purchase"
          }
          color="#FF9800"
          hideTooltip={hideTooltip}
        />
      )}
    </span>
  );
}

LineItemQtyCell.propTypes = {
  lineItem: T.shape({}).isRequired,
  hideTooltip: T.bool,
  type: T.string.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/LineItemQtyCell/LineItemQtyCell.jsx